export const colors = {
    borderColor: '#CCCCCC',
    projectLightBlue: '#376EB4',
    projectDarkBlue: '#004673',
    projectBlue: '#0A5A96',
    projectOrange: '#FFB300',
    white: '#FFFFFF',
    black: '#000000',
    resultColorLineBg: '#F4F4F4',
    btnDsiabled: '#D9D9D9',
    radioBackground: '#999999',
    radioBoxShadow: '#CBD2D2',
    btnColor: '#222222',
};
